import React, { Component } from "react"
import { Card, Col, Row } from "antd"
import CsIcon from "../../../components/iconfont/CsIcon"
import LineIcon from "../../../components/iconfont/LineIcon"
import global from "../../../global"
import intl from "react-intl-universal"


class ServiceCard extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }


    render () {
        let cardHeadStyle = { height: '56px', backgroundColor: '#FAFAFA' }
        let serviceCardList = [
            {
                title: intl.get('sys.menu_group1'),
                list: [
                    {
                        icon: <CsIcon type="line-rtm" className="color-1890FF" />,
                        name: intl.get('sys.rtm_0'),
                        desc: intl.get('console.m_rtm_desc'),
                        serviceId: global.service.RTM
                    },
                    {
                        icon: <CsIcon type="line-rta" className="color-1890FF" />,
                        name: intl.get('sys.rta_16'),
                        desc: intl.get('console.m_rta_desc'),
                        serviceId: global.service.RTM
                    },
                    {
                        icon: <CsIcon type="line-rtv" className="color-1890FF" />,
                        name: intl.get('sys.rtv_15'),
                        desc: intl.get('console.m_rtv_desc'),
                        serviceId: global.service.RTM
                    }
                ]
            },
            {
                title: intl.get('sys.menu_group2'),
                list: [
                    {
                        icon: <CsIcon type="line-stt" className="color-1890FF" />,
                        name: intl.get('sys.rtvt_17'),
                        desc: intl.get('console.m_rtvt_desc'),
                        serviceId: global.service.RTVT
                    },
                    {
                        icon: <CsIcon type="line-alt" className="color-1890FF" />,
                        name: intl.get('sys.alt_4'),
                        desc: intl.get('console.m_alt_desc'),
                        serviceId: global.service.ALT
                    },
                    {
                        icon: <CsIcon type="line-stt" className="color-1890FF" />,
                        name: intl.get('sys.stt_8'),
                        desc: intl.get('console.m_stt_desc'),
                        serviceId: global.service.STT
                    },
                    {
                        icon: <CsIcon type="line-stn" className="color-1890FF" />,
                        name: intl.get('sys.stn_13'),
                        desc: intl.get('console.m_stn_desc'),
                        serviceId: global.service.STN
                    }
                ]
            },
            {
                title: intl.get('sys.menu_group3'),
                list: [
                    {
                        icon: <CsIcon type="line-dts" className="color-1890FF" />,
                        name: intl.get('sys.dts_7'),
                        desc: intl.get('console.m_dts_desc'),
                        serviceId: global.service.DTS
                    },
                    {
                        icon: <CsIcon type="line-pir" className="color-1890FF" />,
                        name: intl.get('sys.pir_10'),
                        desc: intl.get('console.m_pir_desc'),
                        serviceId: global.service.PIR
                    },
                    {
                        icon: <CsIcon type="line-aur" className="color-1890FF" />,
                        name: intl.get('sys.aur_11'),
                        desc: intl.get('console.m_aur_desc'),
                        serviceId: global.service.AUR
                    },
                    {
                        icon: <CsIcon type="line-vir" className="color-1890FF" />,
                        name: intl.get('sys.vir_12'),
                        desc: intl.get('console.m_vir_desc'),
                        serviceId: global.service.VIR
                    }
                ]
            },
        ]


        let row = serviceCardList.map((card, index) =>
            <Col key={'col-'+index} span={8} lg={8} sm={12}>
                <Card title={card.title} key={index} headStyle={cardHeadStyle} bodyStyle={{ padding: '15px 16px' }}>
                    {card.list.map((info, idx) =>
                        <div key={idx} className="card-line-content" onClick={() => { this.props.callback(info.serviceId) }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    {info.icon}
                                    <span className="card-line-content-title" style={{ marginLeft: '12px', fontSize: '14px' }}>{info.name}</span>
                                </div>
                                <div className="card-line-content-type">
                                    <LineIcon type="line-arrow-right" className="color-1890FF" />
                                </div>
                            </div>
                            <div className="card-line-content-desc">{info.desc}</div>
                        </div>
                    )}
                </Card>
            </Col>
        )

        return (
            <Row gutter={[20, 20]} wrap={true} justify="start">
                {row}
            </Row>
        )
    }
}

export default ServiceCard
